import { INTEGRATIONS_MAPPING } from 'lusha-integrations-widgets';
import { PLATFORMS } from '../../models/UserSettings/constants';
const LUSHA_INTEGRATIONS = {
    Salesforce: 'salesforce',
    SalesforceSandbox: 'sfSandbox',
    Hubspot: 'hubspot',
    Outreach: 'outreach',
    Lusha: 'lusha',
    Pipedrive: 'pipedrive',
    Salesloft: 'salesloft',
    Zoho: 'zoho',
    Bullhorn: 'bullhorn',
    Dynamics: 'dynamics',
};
const isLushaLists = integrationKey => integrationKey === LUSHA_INTEGRATIONS.Lusha;
const getIntegrationDisplayName = integrationKey => { var _a; return isLushaLists(integrationKey) ? 'table' : (_a = INTEGRATIONS_MAPPING[integrationKey]) === null || _a === void 0 ? void 0 : _a.displayName; };
const getTextFieldWidthByPlatform = platform => {
    switch (platform) {
        case PLATFORMS.GMAIL:
            return '232';
        default:
            return null;
    }
};
const ONBOARDING_VIEWED_VARIABLE_NAME = '__ov';
export { getIntegrationDisplayName, getTextFieldWidthByPlatform, isLushaLists, LUSHA_INTEGRATIONS, ONBOARDING_VIEWED_VARIABLE_NAME, };
